<template>
  <div>
    <Modal
      ref="modal"
      title="Import Candidates"
      body="You can import your candidates from a CSV file."
      action="Start Import"
      action-color="indigo"
      :cancel-only="file.length === 0"
      @close-modal="emit('handle-close')"
      @handle-action="startImport"
    >
      <p class="text-sm text-gray-500 my-4">
        Download our
        <a href="/candidates_template.csv" target="_blank" class="text-indigo-600 font-semibold">candidates template</a>
        CSV, add in your candidates, and then upload here.
      </p>
      <FileInput
        label="Candidates Import CSV"
        accept=".csv"
        multiple="false"
        :model-value="file"
        @update:model-value="file = $event"
      />
    </Modal>
  </div>
</template>

<script setup lang="ts">
import { defineEmits, ref } from 'vue';
import Modal from '../shared/Modal.vue';
import FileInput from '../shared/FileInput.vue';
import { hFetch } from '@/lib/hfetch';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

const emit = defineEmits(['handle-close']);
const loadingStore = useLoadingSpinnerStore();
const file = ref<File[]>([]);

async function startImport() {
  let formData = new FormData();
  formData.append('candidate_import_request[file]', file.value[0], file.value[0].name);

  const response = await hFetch({ url: '/api/candidate_import_requests', method: 'POST', payload: formData });
  loadingStore.hideLocalLoadingSpinner();
  if (response.status === 'success') {
    emit('handle-close');
    toast.success('Uploaded Successfully', {
      description: 'Your import request has been queued, you will received an email with the results shortly.',
    });
  } else {
    toast.error('Upload Failed', {
      description: response.messages.join(', '),
    });
  }
}
</script>
